// extracted by css-extract-rspack-plugin
export default {"cls1":"SourceAnchoredWorkCard-cls1_UJ_","cls2":"SourceAnchoredWorkCard-cls2_M7k SourceAnchoredWorkCard-cls1_UJ_"};